import type { ErrorCode, Quota } from "../shared/api.ts";

export class ApiError extends Error {
  status: number;
  code: ErrorCode | "network";
  quota?: Quota;
  constructor(status: number, code: ErrorCode | "network", message?: string, quota?: Quota) {
    super(message ?? code);
    this.status = status;
    this.code = code;
    this.quota = quota;
  }
  /** 伺服器有給可以直接顯示的說明時才有值。 */
  get detail() { return this.message === this.code ? "" : this.message; }
}

export async function api<T>(path: string, body?: unknown, method = body === undefined ? "GET" : "POST"): Promise<T> {
  let res: Response;
  try {
    res = await fetch(path, {
      method,
      headers: body === undefined ? undefined : { "Content-Type": "application/json" },
      body: body === undefined ? undefined : JSON.stringify(body),
      credentials: "same-origin",
    });
  } catch {
    throw new ApiError(0, "network");
  }
  const data = await res.json().catch(() => null);
  if (!res.ok) throw new ApiError(res.status, data?.error ?? "upstream", data?.message, data?.quota);
  return data as T;
}

export const $ = <T extends HTMLElement = HTMLElement>(id: string) => document.getElementById(id) as T;

export const esc = (s: unknown) =>
  String(s).replace(/[&<>"']/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]!);

export function fmtReset(at: number) {
  const d = new Date(at);
  const hm = d.toLocaleTimeString("zh-TW", { hour: "2-digit", minute: "2-digit", hour12: false });
  return new Date().toDateString() === d.toDateString() ? `今天 ${hm}` : `明天 ${hm}`;
}

export async function logout() {
  await api("/auth/logout", {}).catch(() => {});
  location.reload();
}
